// extracted by mini-css-extract-plugin
export var locationCard = "_nz-0";